import { CnCard } from '@/components/cn-card';

export default CnCard;
